if (!customElements.get('bf-gallery-page')) {
  customElements.define(
    'bf-gallery-page',
    class BFGalleryPage extends HTMLElement {
      connectedCallback() {
        this.filters = Array.from(this.querySelectorAll('[data-bf-gallery-filter]'));
        this.items = Array.from(this.querySelectorAll('[data-bf-gallery-item]'));
        this.empty = this.querySelector('[data-bf-gallery-empty]');
        this.validCategories = new Set(this.filters.map((filter) => filter.dataset.category || 'all'));
        this.openButtons = Array.from(this.querySelectorAll('[data-bf-gallery-open]'));
        this.closeButtons = Array.from(this.querySelectorAll('[data-bf-gallery-close]'));

        this.normalizePosterPreviewLinks();

        this.filters.forEach((filter) => {
          filter.addEventListener('click', () => {
            const category = filter.dataset.category || 'all';
            this.applyFilter(category, true);
          });
        });

        this.openButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const item = button.closest('[data-bf-gallery-item]');
            if (item) this.toggleMiniGallery(item);
          });
        });

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const item = button.closest('[data-bf-gallery-item]');
            if (item) this.closeMiniGallery(item);
          });
        });

        const initialCategory = this.categoryFromHash();
        this.applyFilter(initialCategory);
      }

      normalizePosterPreviewLinks() {
        this.querySelectorAll('a[href*="/pages/poster-preview"]').forEach((link) => {
          try {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            if (url.pathname !== '/pages/poster-preview') return;

            url.searchParams.set('view', 'poster-preview-names');
            url.searchParams.set('selector_rev', 'clean16');
            link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          } catch (error) {
            // If a theme editor value ever creates a malformed URL, leave it unchanged.
          }
        });
      }

      categoryFromHash() {
        const hash = window.location.hash.replace('#gallery-', '');
        return this.validCategories.has(hash) ? hash : 'all';
      }

      applyFilter(category, updateHash = false) {
        let visibleCount = 0;

        this.filters.forEach((filter) => {
          filter.setAttribute('aria-pressed', filter.dataset.category === category ? 'true' : 'false');
        });

        this.items.forEach((item) => {
          const itemCategories = (item.dataset.categories || item.dataset.category || '').split(/\s+/);
          const visible = category === 'all' || itemCategories.includes(category);
          item.hidden = !visible;
          if (!visible) this.closeMiniGallery(item);
          if (visible) visibleCount += 1;
        });

        if (this.empty) this.empty.hidden = visibleCount > 0;

        if (updateHash) {
          const hash = category === 'all' ? window.location.pathname : `${window.location.pathname}#gallery-${category}`;
          window.history.replaceState({}, '', hash);
        }
      }

      toggleMiniGallery(item) {
        const panel = item.querySelector('[data-bf-gallery-panel]');
        if (!panel) return;

        const expanded = panel.hidden;
        panel.hidden = !expanded;
        item.classList.toggle('is-expanded', expanded);

        item.querySelectorAll('[data-bf-gallery-open]').forEach((button) => {
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });

        if (expanded) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      closeMiniGallery(item) {
        const panel = item.querySelector('[data-bf-gallery-panel]');
        if (!panel) return;

        panel.hidden = true;
        item.classList.remove('is-expanded');

        item.querySelectorAll('[data-bf-gallery-open]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
      }
    }
  );
}
